<template>
    <div>
        <transition name="fade">
            <div v-show="visible" :class="[$style['share-scroll'], 'j-filter-calc-share']" data-margin-top="40">
                <button v-if="level && isLevelFlat"
                        type="button"
                        @click="$emit('getPdfLink')">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" rx="20"/>
                        <path d="M20.2 13V21.4848M20.2 21.4848L23 18.5152M20.2 21.4848L17.4 18.5152M15 23.6061V27H25V23.6061"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"/>
                    </svg>
                </button>

                <v-popover v-if="!shareIsEmpty" :open="popoverOpen"
                           @show="updateLink"
                           trigger="click"
                           popoverClass="is-default"
                           ref="popover"
                           placement="left"
                           :class="$style['share-scroll__item']">
                    <span>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0" width="40" height="40" rx="20"/>
                            <circle cx="24.7543" cy="20.0043" r="1.97301" stroke="white" stroke-width="1.25"/>
                            <circle cx="16.3109" cy="15.4535" r="1.97301" stroke="white" stroke-width="1.25"/>
                            <circle cx="16.3109" cy="24.5433" r="1.97301" stroke="white" stroke-width="1.25"/>
                            <path d="M22.8043 18.6985L18.2578 16.75M22.4796 20.9718C22.4796 21.2316 19.6651 22.5955 18.2578 23.245"
                                  stroke="white"
                                  stroke-width="1.25"/>
                        </svg>
                    </span>

                    <template slot="popover">
                        <Share @popoverClose="popoverOpen = !popoverOpen"
                               :share="share"
                               @shareMail="shareMail"
                               :link="link">
                        </Share>
                    </template>
                </v-popover>
            </div>
        </transition>

        <Popup ref="popup"
               :isSuccess="isFormSuccess"
               :isError="isFormError"
               @popupClose="setFormInit">
            <ShareMail :personLink="personLink"
                       :isSuccess="isFormSuccess"
                       :isError="isFormError"
                       @formSuccess="setFormSendSuccess"
                       @formError="setFormSendError" />
        </Popup>
    </div>
</template>

<script>
    import Popup from '../Popup/Popup';
    import Share from '../Share/Share';
    import ShareMail from '../ShareMail/ShareMail';
    import Sticky from 'sticky-js';

    export default {
        components: {
            Share,
            Popup,
            ShareMail
        },

        props: ['personLink', 'share', 'level'],

        data: () => ({
            popoverOpen: false,
            visible: false,
            link: window.location.href,
            isFormError: false,
            isFormSuccess: false,
            stickyShare: null
        }),

        computed: {
            shareIsEmpty() {
                return Object.keys(this.share).length === 0 && this.share.constructor === Object;
            },

            isLevelFlat() {
                return this.level === 'flat';
            }
        },

        mounted() {
            this.container = document.getElementById('mortgage-calc-list');
            window.addEventListener('scroll', this.scroll, false);
            this.stickyShare = new Sticky(`.j-filter-calc-share`);
        },

        methods: {
            shareMail() {
                this.$refs.popup.open();
                this.popoverOpen = false;
            },

            scroll() {
                const top = this.container.getBoundingClientRect().top;

                if (top < 0 && !this.visible) {
                    this.visible = true;
                } else if (top > 0 && this.visible) {
                    this.visible = false;
                    this.popoverOpen = false;
                }
            },

            updateLink() {
                this.popoverOpen = true;
                this.link = window.location.href;
            },

            setFormSendSuccess() {
                this.isFormSuccess = true;
                this.isFormError = false;
            },

            setFormSendError() {
                this.isFormSuccess = false;
                this.isFormError = true;
            },

            setFormInit() {
                this.isFormSuccess = false;
                this.isFormError = false;
            }
        },

        destroyed() {
            window.removeEventListener('scroll', this.scroll, false);
            this.stickyShare.destroy();
        }
    }
</script>

<style lang="scss" module>
    .share-scroll {
        @include scale(width, 40, 40, 48);
        @include scale(top, 30, 30, 30);
        @include scale(right, -20, -20, -25);
        @include scale(padding-bottom, 20, 20, 20);
        position: absolute;
        display: none;

        @media #{$tablet-landscape} {
            display: block;
        }

        button {
            @include reset-button();
        }

        a,
        button,
        span {
            @include scale(width, 40, 40, 48);
            @include scale(height, 40, 40, 48);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            text-decoration: none;
            color: inherit;

            &:not(:last-child) {
                @include scale(margin-bottom, 16, 16, 16);
            }

            svg {
                display: block;
                width: 100%;
                height: auto;

                rect {
                    @include transition(fill);
                    fill: $brand-accent-dark;
                }
            }

            &:hover {
                svg {
                    rect {
                        // Media
                        @media #{$laptop} {
                            fill: $brand-accent;
                        }
                    }
                }
            }
        }
    }

    .share-scroll__item {
        cursor: pointer;
    }
</style>
